import {
    recipesService
} from '../service/recipesService';

//
const recipes = {
    namespaced: true,
    state: {
        shipping_runs: [],
        meal_plans: [],
        food_groups: []
    },
    mutations: {
        updateShippingRuns: (state, runs) => {
            state.shipping_runs = runs;
        },
        updateMealPlans: (state, plans) => {
            state.meal_plans = plans;
        },
        updateFoodGroups: (state, groups) => {
            state.food_groups = groups;
        }
    },
    actions: {
        getLatestShippingRuns: async ({ commit }) => {
            const data = await recipesService.getShippingRuns();
            commit('updateShippingRuns', data);
            return data;
        },
        getRecipes: async ({ commit }, params) => {
            const data = await recipesService.getRecipesForShippingRun(
                params.id,
                params.query ? params.query : '',
                params.meal_plan ? params.meal_plan : '',
                params.portion_count ? params.portion_count : ''
            );
            return data;
        },
        filterRecipes: async ({ commit }, params) => {
            switch (params.filter) {
                case 'selected':
                    return params.recipes.filter(a => {
                        return params.selected.find(b => {
                            return a.id == b.id;
                        });
                    });
                    break;
            }
            return params.recipes;
        },
        sortRecipes: async ({ commit }, params) => {
            return params.recipes;
        },
        loadMealPlans: async ({ commit }) => {
            const data = await recipesService.getMealPlans();
            commit('updateMealPlans', data);
            return data;
        },
        loadFoodGroups: async ({ commit }) => {
            const data = await recipesService.getFoodGroups();
            commit('updateFoodGroups', data);
            return data;
        }
    },
    getters: {

    }
}
//
export default recipes